import { createFileRoute } from "@tanstack/react-router";
import { TenantRecordPage } from "@/features/tenants/pages/tenant-record-page";
export const Route = createFileRoute("/_authed/tenant-records/$slug/")({ component: TenantRecordPage });
